import React from 'react';
import imageSubscription from "../../../../images/subscription.jpg";
import imageAboutApp from "../../../../images/about-app.jpg";
import imageIntroCompany from "../../../../images/intro-company.jpg";
import imageEltonsSmall from "../../../../images/eltons-small.png";
import imageGooglePlay from "../../../../images/app-google-play.png";
import imageAppStore from "../../../../images/app-appstore.png";
import imageAppQR from "../../../../images/app-qr-code.gif";
import imageSlideVideo from "../../../../images/slide-video.jpg";
import imageSlideVideoMobile from "../../../../images/slide-video-mobile.jpg";
import pdf from "../../../../download/mooveez-vice-nez-film-i-kurz.pdf"

class MainSection extends React.Component {

    constructor(props) {
        super(props);
        this.updateDimensions = this.updateDimensions.bind(this);

        this.subscriptionRef = React.createRef();
        this.aboutAppRef = React.createRef();

        this.state = {
            subscriptionImgHeight: null,
            aboutAppImgHeight: null,
        };
    };

    updateDimensions() {
        console.log(this.subscriptionRef);
        this.setState({
            subscriptionImgHeight : this.subscriptionRef.current.clientHeight+"px",
            aboutAppImgHeight : this.aboutAppRef.current.clientHeight+"px"
        });
    };

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions);
        window.addEventListener("load", this.updateDimensions);
    };

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
        window.removeEventListener("load", this.updateDimensions);
    }

    render() {
        const aboutAppImgStyle = { height : this.state.aboutAppImgHeight};
        const subscriptionImgStyle = { height : this.state.subscriptionImgHeight };
        const {userCount, moduleCount, exerciseCount, teachingDurationInHours} = this.props.statisticData;
        return (
            <React.Fragment>
                <section className="section9">
                    <img src={imageIntroCompany} alt="" className="mobile-hide"/>
                    <img src={imageIntroCompany} alt="" className="mobile-show"/>&nbsp;

                    <div className="box-gradient"></div>

                    <div className="box">
						<div className="mobile-show app-links">
							<p className="app-links">
								<a href="https://itunes.apple.com/cz/app/movies-for-ipad/id827925361?mt=8" target="_blank" rel="noopener noreferrer" className="appstore"><img src={imageAppStore} alt="App Store"/></a>
								<a href="https://play.google.com/store/apps/details?id=cz.ai.aschool.movies" target="_blank" rel="noopener noreferrer" className="googleplay"><img src={imageGooglePlay} alt="Google Play"/></a>
								<br className="cl"/>
							</p>
						</div>
						<div className="mobile-hide app-qr-code">
							<p>
								<img src={imageAppQR} alt="App Store / Gogle Play"/>
								Vyzkoušejte<br/>
								Mooveez<br/>
								zdarma
							</p>
						</div>
                        <div className="col-left">
                            <div className="block-valign">
                                <h2>
                                    <span>Mooveez</span><br/>
                                    pro firmy<br/>
                                </h2>
                                <p>
                                    Věnujte vašim zaměstnancům nebo obchodním partnerům možnost
                                    <strong> rozvíjet angličtinu způsobem, který tu nikdy předtím nebyl,</strong> a to
                                    zábavně prostřednictvím <strong>filmů a seriálů</strong>.
                                </p>
                                <p>
                                    <a href={pdf} className="btn tcs" target="_blank">ZJISTIT VÍCE (e-book ke stažení)</a>
                                </p>
                                <p>
                                    <a onClick={this.props.onOrder} className="btn">objednejte
                                        zde</a>
                                </p>
                            </div>
                        </div>
                        <div className="col-right">
                            <h3>
                                <img src={imageEltonsSmall}
                                     alt="ELTons winner 2016"/>
                                Vítěz kategorie<br/>
                                Digitální inovace<br/>
                                roku 2016<br/>
                                <span>celosvětová soutěž ELTons<br/>
					pořádaná British Council</span>
                            </h3>
                        </div>
                        <div className="cl"></div>
                    </div>
                    <div className="cl"></div>
                </section>

                <section className="section10">
                    <div className="text-center">
                        <h2><span>Mooveez v</span> číslech</h2>
                    </div>
                    <div className="box">
                        <div className="stats">
                            <div className="col-4 first-2">
                                <strong className="icon-globe">{userCount === null ? 0 : userCount.toLocaleString("cs-CZ")}</strong>
                                studentů registrovaných po celém světě
                            </div>
                            <div className="col-4 first-2">
                                <strong className="icon-hour">{teachingDurationInHours === null ? 0 : teachingDurationInHours.toLocaleString("cs-CZ")}</strong>
                                hodin výuky s filmy
                            </div>
                            <div className="col-4">
                                <strong className="icon-light">{exerciseCount === null ? 0 : exerciseCount.toLocaleString("cs-CZ")}</strong>
                                kvízů, cvičení a testů
                            </div>
                            <div className="col-4 last">
                                <strong className="icon-film">{moduleCount === null ? 0 : moduleCount.toLocaleString("cs-CZ")}</strong>
                                filmů, seriálů a dokumentů
                            </div>
                            <br className="cl"/>
                        </div>
                        <br className="cl"/>
                    </div>
                </section>

                <section className="cn-about-app">
                    <div className="box-wide">
                        <div className="col-2">
                            <div className="texts-right" id="about-app" ref= {this.aboutAppRef}>
                                <h2>
                                    Jedinečné funkce,<br/>
                                    <span>které umožňují<br/>
            efektivní a zábavnou<br/>
            výuku s filmem</span>
                                </h2>
                                <ul>
                                    <li>filmy jsou rozděleny do lekcí, na které navazují jazyková cvičení a kvízy</li>
                                    <li>filmy lze přehrávat v originále na celé obrazovce nebo s přesným přepisem a titulky opatřenými kulturními vysvětlivkami</li>
                                    <li>z každé věty ve filmu lze vytvořit ozvučenou kartičku pro snadné naučení fráze</li>
                                    <li>kartičky umožňují nahrávání vlastní výslovnosti a porovnání s původní výslovností herce</li>
                                    <li>funkce "tap dialogs" umožňuje snadné ovládání filmu s možností vrátit se přesně na začátek věty, kterou si potřebujete přehrát vícekrát</li>
                                    <li>a mnoho dalšího!</li>
                                </ul>
                                <p>
                                    <a onClick={this.props.onOrder} className="btn">objednejte zde</a>
                                </p>
                            </div>
                        </div>
                        <div className="col-2 img-box" id="about-app-img" style={aboutAppImgStyle}>
                        </div>
                        <img src={imageAboutApp} className="mobile-show" alt=""/>
                        <div className="cl"></div>
                    </div>
                </section>

                <section className="cn-subscription">
                    <div className="box-wide">
                        <div className="col-2 img-box" id="subscription-img" style={subscriptionImgStyle}>
                        </div>
                        <div className="col-2">
                            <div className="texts-right" id="subscription" ref={this.subscriptionRef}>
                                <h2>
                                    <div className="action-dot">
                                        <p>
                                            949 Kč<br/>
                                            <span>na rok</span>
                                        </p>
                                    </div>
                                    <span>Věnujte</span> roční<br/>
                                    předplatné,<br/>
                                    <span>které obsahuje</span>
                                </h2>
                                <ul>
                                    <li>nabídku <strong>desítek titulů</strong>, která se každý měsíc rozrůstá</li>
                                    <li><strong>stovky jazykových lekcí</strong></li>
                                    <li><strong>tisíce cvičení a kvízů</strong></li>
                                    <br/>
                                    <li>vše zpracováno unikátní metodou Mooveez</li>
                                    <li>u všech titulů jsou ošetřena autorská práva</li>
                                    <li>překlad filmů je přesný a podléhá mnohonásobné kontrole kvality</li>
                                    <li>mobilní platforma zajištuje častý kontakt s angličtinou bez nutnosti zásahu do denního rozvrhu</li>
                                    <li>zapojením více smyslů se zvyšuje rychlost a trvanlivost učení</li>
                                    <li>systém připomínek pro vytvoření návyku na pravidelné studium</li>
                                </ul>
                                <p>
                                    <a onClick={this.props.onOrder} className="btn">objednejte zde</a>
                                </p>
                            </div>
                        </div>
                        <img src={imageSubscription} className="mobile-show" alt=""/>
                        <div className="cl"></div>
                    </div>
                </section>

                <section className="section9 video-play">
                    <a href="https://youtu.be/pDIla_Smloo" target="_blank" rel="noopener noreferrer">
                    	<img src={imageSlideVideo} alt="" className="mobile-hide" />
                    	<img src={imageSlideVideoMobile} alt="" className="mobile-show" />
                    	<div className="cl"></div>
                    	<div className="box">
							<div className="col-left">
								<h2>
									Představte si svět,<br/>
									<span>ve kterém si lidé rozumí</span>
								</h2>
								<p>
									<span className="btn">PŘEHRÁT VIDEO</span>
								</p>
							</div>
						</div>
					 </a>
                </section>
            </React.Fragment>
        );
    }
}

export default MainSection;


// WEBPACK FOOTER //
// ./src/components/company/section/view/MainSection.jsx